// Robust vCard 3.0 builder that iOS/Android correctly parse into first/last name + typed fields.
// Escapes reserved chars per RFC 6350, uses CRLF line endings, includes structured N: field.

function esc(v) {
  if (!v) return "";
  return String(v)
    .replace(/\\/g, "\\\\")
    .replace(/;/g, "\\;")
    .replace(/,/g, "\\,")
    .replace(/\n/g, "\\n");
}

function splitName(fullName) {
  const parts = (fullName || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { first: "", last: "", middle: "" };
  if (parts.length === 1) return { first: parts[0], last: "", middle: "" };
  const last = parts[parts.length - 1];
  const first = parts[0];
  const middle = parts.slice(1, -1).join(" ");
  return { first, last, middle };
}

export function buildVCard({ name, email, phone, title, company, website, linkedin, tagline, bio, address }) {
  const { first, last, middle } = splitName(name);
  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `N:${esc(last)};${esc(first)};${esc(middle)};;`,
    `FN:${esc(name || "")}`,
  ];
  if (company) lines.push(`ORG:${esc(company)}`);
  if (title) lines.push(`TITLE:${esc(title)}`);
  if (phone) lines.push(`TEL;TYPE=CELL,VOICE:${esc(phone)}`);
  if (email) lines.push(`EMAIL;TYPE=INTERNET,WORK:${esc(email)}`);
  if (website) {
    const url = website.startsWith("http") ? website : `https://${website}`;
    lines.push(`URL:${esc(url)}`);
  }
  if (linkedin) {
    const url = linkedin.startsWith("http") ? linkedin : `https://${linkedin}`;
    lines.push(`URL;TYPE=LinkedIn:${esc(url)}`);
  }
  if (tagline || bio) {
    lines.push(`NOTE:${esc(tagline ? tagline + (bio ? " · " + bio : "") : bio)}`);
  }
  if (address) lines.push(`ADR;TYPE=WORK:;;${esc(address)};;;;`);
  lines.push("END:VCARD");
  // CRLF line endings per vCard spec
  return lines.join("\r\n");
}

export function downloadVCard(vcard, filename) {
  const blob = new Blob([vcard], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "contact.vcf";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
